'use client';

import { BackgroundBlobs } from '@repo/ui/components/background-blobs';
import { Button } from '@repo/ui/components/button';
import { LogoTitle } from '@repo/ui/components/logo-title';
import { Section } from '@repo/ui/components/section';
import { Link } from '@repo/ui/i18n/navigation';
import { useTranslations } from 'next-intl';
import { getTranslations } from 'next-intl/server';

export async function generateMetadata() {
  const t = await getTranslations('not_found_page');
  return {
    title: t('title'),
    description: t('description'),
  };
}

export default function NotFoundPage() {
  const t = useTranslations('not_found_page');

  return (
    <Section
      id='not-found'
      className='relative bg-gradient-to-br from-purple-50/50 via-white to-pink-50/50 overflow-hidden min-h-screen flex items-center justify-center'
    >
      <BackgroundBlobs />
      <div className='relative z-10 container mx-auto px-4 py-12 text-center'>
        <div className='max-w-md mx-auto'>
          <LogoTitle
            logo='/logo.webp'
            title='AvatarCreator'
            logoWidth={80}
            logoHeight={80}
            className='justify-center mb-8'
          />
          <h1
            className='text-6xl sm:text-7xl lg:text-8xl font-bold text-gray-900 mb-6 text-balance'
            style={{
              textRendering: 'optimizeLegibility',
              WebkitFontSmoothing: 'antialiased',
            }}
          >
            404
          </h1>
          <h2
            className='text-2xl sm:text-3xl font-semibold text-gray-800 mb-4 text-balance'
            style={{
              textRendering: 'optimizeLegibility',
              WebkitFontSmoothing: 'antialiased',
            }}
          >
            {t('title')}
          </h2>
          <p className='text-lg text-gray-600 mb-10 text-balance'>
            {t('description')}
          </p>
          <Link href='/'>
            <Button size='lg' className='gap-2 rounded-full'>
              {t('go_home')}
            </Button>
          </Link>
        </div>
      </div>
    </Section>
  );
}
